import {SpanIcon} from '@mazraeapp/react_icon_kit';
import Modal from '../../../../../../components/mazraeKit/modal';

interface IEmptyFarmModalProps {
  isEmptyFarmModal: boolean;
  setIsEmptyFarmModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const EmptyFarmModal = ({
  setIsEmptyFarmModal,
  isEmptyFarmModal,
}: IEmptyFarmModalProps) => {
  return (
    <Modal isOpen={isEmptyFarmModal} setIsOpen={setIsEmptyFarmModal}>
      <div className="w-[320px] flex flex-col p-3 gap-3">
        <div className="flex items-center justify-between">
          <div className="flex w-[90%] justify-center">
            <SpanIcon className="icon-nameCheck-circle text-xxl  text-farm-shop-500" />
          </div>
          <button onClick={() => setIsEmptyFarmModal(false)}>
            <SpanIcon className="icon-nameClose-remove text-xl text-gray-700 w-[10%]" />
          </button>
        </div>
        <h5 className="w-full text-gray-950 flex justify-center">
          شما مزرعه‌ای ندارید!
        </h5>
        <p className="w-full p-0 m-0 text-gray-700 text-md font-Regular">
          برای ثبت آگهی فروش زمین خود، لازم است ابتدا زمین خود را در سامانه
          مزرعه ثبت کنید.
        </p>
        <button className="bg-farm-shop-500 text-white rounded h-10 w-full mt-1 text-regular text-sm">
          ثبت مزرعه
        </button>
      </div>
    </Modal>
  );
};

export default EmptyFarmModal;
